/**
 * @generated SignedSource<<89e7f6b8dcdf372aae6112d0fb984c1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shortId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "shortId",
    "variableName": "shortId"
  }
],
v3 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 16
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyExcerpt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pictureUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v13 = [
  (v4/*: any*/),
  (v8/*: any*/)
],
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 666
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MessagesQuery",
    "selections": [
      {
        "alias": "conversation",
        "args": (v2/*: any*/),
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversationByShortId",
        "plural": false,
        "selections": [
          {
            "args": [
              (v3/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "Messages_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MessagesQuery",
    "selections": [
      {
        "alias": "conversation",
        "args": (v2/*: any*/),
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversationByShortId",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": "messages",
            "args": (v5/*: any*/),
            "concreteType": "MessagesConnection",
            "kind": "LinkedField",
            "name": "messagesByConversationId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MessagesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "readBy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sender",
                        "storageKey": null
                      },
                      {
                        "alias": "user",
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "userByUserId",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "family",
                        "args": null,
                        "concreteType": "Family",
                        "kind": "LinkedField",
                        "name": "familyByFamilyId",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "contact",
                        "args": null,
                        "concreteType": "Contact",
                        "kind": "LinkedField",
                        "name": "contactByContactId",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "partner",
                        "args": null,
                        "concreteType": "Partner",
                        "kind": "LinkedField",
                        "name": "partnerByPartnerId",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "parts",
                        "args": (v14/*: any*/),
                        "concreteType": "PartsConnection",
                        "kind": "LinkedField",
                        "name": "partsByMessageId",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Part",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "order",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mimeType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "body",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "formattedBody",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "content",
                                    "storageKey": null
                                  },
                                  (v15/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "partsByMessageId(first:666)"
                      },
                      {
                        "alias": "parts",
                        "args": (v14/*: any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "Messages_parts",
                        "kind": "LinkedHandle",
                        "name": "partsByMessageId"
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "messages",
            "args": (v5/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "Conversation_messages",
            "kind": "LinkedHandle",
            "name": "messagesByConversationId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c4ae566adc8b67e638f853ac0396121c",
    "id": null,
    "metadata": {},
    "name": "MessagesQuery",
    "operationKind": "query",
    "text": "query MessagesQuery(\n  $shortId: String!\n  $after: Cursor\n) {\n  conversation: conversationByShortId(shortId: $shortId) {\n    ...Messages_viewer_WGPvJ\n    id\n  }\n}\n\nfragment MessageRow_message on Message {\n  id\n  userId\n  bodyExcerpt\n  createdAt\n  sender\n  user: userByUserId {\n    id\n    pictureUrl\n    name\n    firstName\n    lastName\n    email\n    phone\n  }\n  family: familyByFamilyId {\n    id\n    name\n  }\n  contact: contactByContactId {\n    id\n    pictureUrl\n    firstName\n    lastName\n    email\n    phone\n  }\n  partner: partnerByPartnerId {\n    id\n    name\n  }\n  parts: partsByMessageId(first: 666) {\n    edges {\n      node {\n        id\n        order\n        mimeType\n        body\n        bodyExcerpt\n        formattedBody\n        contentUrl\n        content\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Messages_viewer_WGPvJ on Conversation {\n  id\n  shortId\n  title\n  type\n  messages: messagesByConversationId(first: 16, after: $after) {\n    totalCount\n    edges {\n      node {\n        id\n        createdAt\n        readBy\n        ...MessageRow_message\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6ef4cd7eb81d40e9cda0fe32dc290b17";

module.exports = node;
